import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionmobius() {
  return (
    <section
      className="solution_mobius p-100"
      style={{ background: "#FAFAFA" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center resp_order"
          >
            <StaticImage
              src="../../../images/case-studies/mobius/solution.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={910}
              height={627}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#214092" }}>Solutions </span>
              Delivered
            </h2>
            <p>
              TekRevol effectively created Android and iOS apps for Mobius Risk
              Group that addressed their precise requirements.
            </p>
            <p>
              The apps covered features such as real-time market data updates,
              risk analysis tools, modify-able dashboards, and safe data
              transmission.
            </p>
            <p>
              User-friendly interfaces, instinctive navigation, and complete
              functionalities were incorporated into both the Android and iOS
              apps.
            </p>
            <p>
              The development team guaranteed that the mobile apps replicated
              the essential features of the traditional ERP system, authorizing
              users with resourceful risk management proficiencies on their
              mobile devices.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionmobius;
